import { Body1, Body1Strong } from '@fluentui/react-components';
import type { TResolvedItemsMap } from '@modules/items/types/items.types';
import UserLabel from '@modules/users/components/UserLabel';
import { DueDateLabel } from '@shared/components/dates/DueDateLabel';
import ExpandableDescription from '@shared/components/ExpandableDescription';
import { resolveLinkedItems } from '../linkedItems.helper';
import type { TTask, TTaskDue } from '../types';
import TaskLinkedItemsList from './TaskLinkedItemsList';
import TaskPriorityLabel from './TaskPriorityLabel';

type TProps = { task: TTask; resolvedItems: TResolvedItemsMap; due?: TTaskDue };

const TaskDetailsOverview = ({ task, resolvedItems, due }: TProps) => {
  return (
    <div className="grid flex-1 grid-cols-1 grid-rows-[auto_1fr_auto_auto_auto] gap-5 lg:grid-cols-3 lg:grid-rows-[auto_1fr_auto]">
      <div className="min-w-0 lg:col-span-3">
        <TaskLinkedItemsList linkedItems={resolveLinkedItems(task.linkedItems, resolvedItems)} />
      </div>
      <div className="flex min-w-0 flex-col gap-1.5 lg:col-span-3">
        <Body1Strong>Description</Body1Strong>
        <ExpandableDescription description={task.description} />
      </div>
      <div className="flex min-w-0 flex-col gap-1.5">
        <Body1>Assignee</Body1>
        <div className="flex min-h-7 items-center">
          {task.assignee ? (
            <UserLabel id={task.assignee} avatarProps={{}} textProps={{ weight: 'semibold' }} />
          ) : (
            <Body1Strong>Unassigned</Body1Strong>
          )}
        </div>
      </div>
      <div className="flex min-w-0 flex-col gap-1.5">
        <Body1>Due date</Body1>
        <div className="flex min-h-7 items-center">
          <DueDateLabel dueDate={task.dueDate} due={due} />
        </div>
      </div>
      <div className="flex min-w-0 flex-col gap-1.5">
        <Body1>Priority</Body1>
        <div className="flex min-h-7 items-center">
          <TaskPriorityLabel priority={task.priority} />
        </div>
      </div>
    </div>
  );
};
export default TaskDetailsOverview;
